import * as React from 'react';

const AuthenticityDiamond16 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.43 3.5 14 6.26l-6 6-6-6L4.57 3.5h6.86Zm.28-1.5H4.29a.85.85 0 0 0-.62.27L.48 5.69a.87.87 0 0 0 0 1.19l6.91 6.87A.791.791 0 0 0 8 14a.832.832 0 0 0 .6-.25l6.9-6.87a.87.87 0 0 0 0-1.19l-3.17-3.42a.85.85 0 0 0-.62-.27Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m12.243 5.884-1.209-.415-.41-1.206a.367.367 0 0 0-.14-.19.405.405 0 0 0-.466 0 .366.366 0 0 0-.14.19l-.4 1.206-1.209.405a.427.427 0 0 0-.195.15.388.388 0 0 0 0 .453.427.427 0 0 0 .195.149l1.21.405.399 1.206a.366.366 0 0 0 .14.19.405.405 0 0 0 .466 0 .367.367 0 0 0 .14-.19l.41-1.206 1.21-.405a.425.425 0 0 0 .186-.15.388.388 0 0 0 0-.442.425.425 0 0 0-.187-.15Z"
  }
));
AuthenticityDiamond16.Size = 16;
AuthenticityDiamond16.Title = "AuthenticityDiamond";

export { AuthenticityDiamond16 as default };
